<template>
    <ul class="restaurant-cta-list list-unstyled">
        <li
            v-for="restaurant in restaurants"
            :key="restaurant.name"
        >
            <restaurant-cta v-bind="restaurant" />
        </li>
    </ul>
</template>

<script>
    import RestaurantCta from '../../molecules/RestaurantCta/RestaurantCta';

    export default {
        name: 'restaurant-cta-list',

        components: { RestaurantCta },

        props: {
            restaurants: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-cta-list {
        display: grid;
        grid-gap: 60px;
        justify-items: center;
        @include media-breakpoint-up(sm) {
            display: grid;
            grid-template-columns: repeat(2, auto);
        }
        @include media-breakpoint-up(lg) {
            grid-template-columns: repeat(3, auto);
        }
        @include media-breakpoint-up(xl) {
            grid-template-columns: repeat(4, auto);
        }
    }

    .restaurant-cta {
        max-width: 300px;
    }
</style>
